import React from 'react';
import { mlSafeStyle } from '../utils/mlSafe';

// Force the content-aware helper to return its full safe-style object once
// at module load. We then apply that style unconditionally — harmless for
// English text (letter-spacing:0, line-height:1.8, ML-capable font stack),
// and guarantees Malayalam shaping regardless of whether children is a
// string or JSX (where content-sniffing would miss).
const ML_SAFE_BASE = mlSafeStyle('മ');

export const MLText = ({ as: Tag = 'span', children, style, ...rest }) => (
  <Tag style={{ ...ML_SAFE_BASE, ...style }} {...rest}>
    {children}
  </Tag>
);

export default MLText;
